<script setup lang="ts">
import { formatDate, formatExamDistance } from '@/helpers/formatters'
import type { Seminar } from './types'

defineProps<{ educationData: Seminar[] }>()
</script>

<template>
  <h2 class="text-body-bold mb-2">
    Моё обучение
    <span class="gray-text ml-half">{{ educationData.length }}</span>
  </h2>

  <li v-for="seminar in educationData" :key="seminar.title" class="teacher-dashboard__seminar">
    <div class="flex-adaptive justify-space-between mb-1">
      <div class="teacher-dashboard__seminar-badges">
        <template v-if="seminar.status === 'passed'">
          <div v-if="seminar.has_exam" class="teacher-dashboard__seminar-badge blue">Экзамен сдан</div>
          <div class="teacher-dashboard__seminar-badge dark-blue">Пройден</div>
        </template>

        <div v-if="seminar.status === 'passed_offline'" class="teacher-dashboard__seminar-badge dark-blue">
          Пройден офлайн
        </div>

        <template v-if="seminar.status === 'exam_in_progress'">
          <div class="teacher-dashboard__seminar-badge red">Экзамен сегодня</div>
          <div class="teacher-dashboard__seminar-badge green">Идёт</div>
        </template>

        <template v-if="seminar.status === 'active'">
          <div v-if="seminar.has_exam" class="teacher-dashboard__seminar-badge orange">
            {{ formatExamDistance(seminar.finish_date) }}
          </div>
          <div class="teacher-dashboard__seminar-badge green">Идёт</div>
        </template>

        <template v-if="seminar.status === 'future'">
          <div class="teacher-dashboard__seminar-badge gray">Начнётся {{ formatDate(seminar.start_date) }}</div>
        </template>
      </div>

      <div class="text-overline gray-text" v-text="seminar.language" />
    </div>

    <div class="text-body-bold my-1" v-text="seminar.title" />
    <p class="mb-2" v-text="seminar.description" />

    <ul class="teacher-dashboard__seminar-actions text-body-bold">
      <li v-for="(btn, i) in seminar.left_buttons" :key="`l${i}`">
        <v-link mode="primary" :href="btn.link">{{ btn.text }}</v-link>
      </li>
    </ul>
  </li>
</template>
